<template>
  <v-dialog
    v-model="show"
    fullscreen
    :overlay="false"
    :transition="false"
    persistent
    width="900px"
    id="dialog"
    class="text-xs-center">
    <v-card id="cardDialog">
      <v-layout
        row
        wrap
        align-center
        class="text-xs-center font-number">
        <v-flex id="descripPOS" xs12>Waiting for stream...</v-flex>
        <v-flex xs4 />
        <v-flex xs4>
          <p v-if="$store.getters.getNextEvent">{{ $store.getters.getNextEvent.name }}</p>
          <v-progress-linear :indeterminate="true" color="warning" height="8" />
        </v-flex>
        <v-flex xs4 />
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
  }
};
</script>

<style>
#descripPOS {
  margin-top: 400px;
}

#cardDialog {
  background-color: black;
}

#dialog {
  overflow: hidden;
  background: none !important;
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/player/StreamWait.vue